import { render, staticRenderFns } from "./Multiselect.vue?vue&type=template&id=0c859329&scoped=true&"
import script from "./Multiselect.vue?vue&type=script&lang=js&"
export * from "./Multiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c859329",
  null
  
)

export default component.exports